// Rooted v1.0 — Golden Fox Publishing
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AppProvider } from './context/AppContext.jsx';
import ProtectedRoute from './components/auth/ProtectedRoute.jsx';
import EnneagramRequired from './components/auth/EnneagramRequired.jsx';

import Welcome from './screens/Welcome.jsx';
import GuideSetup from './screens/GuideSetup.jsx';
import Intake from './screens/Intake.jsx';
import StudyPlan from './screens/StudyPlan.jsx';
import DayDetail from './screens/DayDetail.jsx';
import Subscribe from './screens/Subscribe.jsx';
import SubscribeSuccess from './screens/SubscribeSuccess.jsx';
import SubscribeCancel from './screens/SubscribeCancel.jsx';
import SignInScreen from './screens/SignIn.jsx';
import SignUpScreen from './screens/SignUp.jsx';
import Terms from './screens/Terms.jsx';
import Privacy from './screens/Privacy.jsx';
import EnneagramAssessment from './screens/EnneagramAssessment.jsx';
import Preparing from './screens/Preparing.jsx';
import ProfileOverview from './screens/ProfileOverview.jsx';
import Journal from './screens/Journal.jsx';
import WeeklyJourney from './screens/WeeklyJourney.jsx';
import Admin from './screens/Admin.jsx';
import VoiceTest from './pages/VoiceTest.jsx';
import AudioModulesTest from './test/AudioModulesTest.jsx';

import GoldenFoxPrototype from './golden-fox-prototype.jsx';
import StackPrototype from './stack-prototype.jsx';

export default function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<Welcome />} />
          <Route path="/sign-in/*" element={<SignInScreen />} />
          <Route path="/sign-up/*" element={<SignUpScreen />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />

          {/* Pre-auth routes — users experience the full intake first */}
          <Route path="/guide-setup" element={<GuideSetup />} />
          <Route path="/intake" element={<Intake />} />

          {/* Auth required routes */}
          <Route path="/enneagram" element={<EnneagramAssessment />} />
          <Route
            path="/preparing"
            element={
              <ProtectedRoute>
                <EnneagramRequired>
                  <Preparing />
                </EnneagramRequired>
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <ProfileOverview />
              </ProtectedRoute>
            }
          />
          <Route
            path="/journal"
            element={
              <ProtectedRoute>
                <EnneagramRequired>
                  <Journal />
                </EnneagramRequired>
              </ProtectedRoute>
            }
          />
          <Route
            path="/journey"
            element={
              <ProtectedRoute>
                <EnneagramRequired>
                  <WeeklyJourney />
                </EnneagramRequired>
              </ProtectedRoute>
            }
          />
          <Route
            path="/study"
            element={
              <ProtectedRoute>
                <EnneagramRequired>
                  <StudyPlan />
                </EnneagramRequired>
              </ProtectedRoute>
            }
          />
          <Route
            path="/study/day/:dayNumber"
            element={
              <ProtectedRoute>
                <EnneagramRequired>
                  <DayDetail />
                </EnneagramRequired>
              </ProtectedRoute>
            }
          />
          <Route
            path="/study/week/:weekNumber"
            element={
              <ProtectedRoute>
                <EnneagramRequired>
                  <StudyPlan />
                </EnneagramRequired>
              </ProtectedRoute>
            }
          />
          <Route
            path="/study/week/:weekNumber/day/:dayNumber"
            element={
              <ProtectedRoute>
                <EnneagramRequired>
                  <DayDetail />
                </EnneagramRequired>
              </ProtectedRoute>
            }
          />
          {/* Paywall — canonical path is /paywall. /subscribe kept as
              an alias because Stripe Checkout success/cancel URLs (set
              server-side in api/create-checkout.js) live under it. */}
          <Route path="/paywall" element={<Subscribe />} />
          <Route path="/subscribe" element={<Subscribe />} />
          <Route
            path="/subscribe/success"
            element={<SubscribeSuccess />}
          />
          <Route path="/subscribe/cancel" element={<SubscribeCancel />} />

          {/* Diagnostic page — bare-bones MediaRecorder + Whisper test */}
          <Route path="/voice-test" element={<VoiceTest />} />

          {/* Day-1 audio rewrite — isolated module test harness */}
          <Route path="/audio-modules-test" element={<AudioModulesTest />} />

          {/* Admin dashboard — public route, password-protected internally */}
          <Route path="/admin" element={<Admin />} />

          {/* Prototype routes preserved for reference */}
          <Route path="/proto/golden-fox" element={<GoldenFoxPrototype />} />
          <Route path="/proto/stack" element={<StackPrototype />} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AppProvider>
  );
}
